// src/pages/Impersonate.js — redeems a one-time impersonation code minted by a
// super-admin in the platform console, then drops into the tenant CRM as that
// user. Reached at /impersonate?code=... on the tenant's own domain.
import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { impersonateExchange } from '../utils/api';

export default function Impersonate() {
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  // The code is SINGLE-USE, and React StrictMode double-invokes effects in dev —
  // without this guard the second run would redeem an already-used code and fail.
  const redeemed = useRef(false);

  useEffect(() => {
    if (redeemed.current) return;
    redeemed.current = true;

    const code = params.get('code');
    if (!code) { setError('This link is missing its code.'); return; }

    impersonateExchange(code)
      .then(r => {
        localStorage.setItem('bc_token', r.data.token);
        localStorage.setItem('bc_user', JSON.stringify(r.data.user));
        // replace() (not navigate) so the page fully reloads into the new session
        // AND the code-bearing URL doesn't stay in back-history.
        window.location.replace('/');
      })
      .catch(e => setError(e.response?.data?.error || 'This impersonation link could not be used.'));
  }, [params]);

  return (
    <div className="login-wrap">
      <div className="login-card" style={{ textAlign: 'center' }}>
        {!error ? (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>Starting impersonated session…</div>
            <div style={{ fontSize: 13, color: 'var(--gray-400)' }}>One moment.</div>
          </>
        ) : (
          <>
            <i className="ti ti-lock-off" style={{ fontSize: 34, color: 'var(--red)', display: 'block', margin: '8px auto 14px' }} />
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Impersonation failed</div>
            <p style={{ fontSize: 13, color: 'var(--gray-600)', marginBottom: 20 }}>{error}</p>
            <p style={{ fontSize: 12, color: 'var(--gray-400)', marginBottom: 16 }}>
              These links are single-use and expire after a couple of minutes — generate a fresh one from the console.
            </p>
            <Link to="/login" className="btn btn-outline" style={{ justifyContent: 'center', display: 'flex' }}>Go to Login</Link>
          </>
        )}
      </div>
    </div>
  );
}
